import { useEffect, useMemo } from 'react';
import { useQuery } from 'react-query';

import PortainerError from '@/core/error';
import * as notifications from '@/core/services/notifications';
import { getProfiles } from '@/core/hostmanagement/fdo/fdo.service';

export function useFDOProfiles() {
  const { isLoading, data, isError, error } = useQuery('fdo_profiles', () =>
    getProfiles()
  );

  useEffect(() => {
    if (isError) {
      notifications.error(
        'Ошибка',
        error as Error,
        'Не удалось загрузить профили FDO'
      );
    }
  }, [isError, error]);

  const profiles = useMemo(() => data || [], [data]);

  return {
    isLoading,
    profiles,
    error: isError ? (error as PortainerError) : undefined,
  };
}
